import { BuildInfo } from "utility/buildinfo";
/*
 * What the app offers in production and what it holds back.
 *
 * Features are tested on uat before they are released, so until then
 * production hides the way into them. Every such gate lives here, so a release
 * is one edit and the list of what is still unreleased is in one place. These
 * read `BuildInfo` at call time, which is also what lets tests flip the
 * environment.
 *
 * Gate only the entry point of a feature. Everything behind it should key on
 * the state the entry point sets (a system's switch, a picked option), never
 * on the environment, so uat with the feature untouched behaves exactly like
 * production and the two can be compared.
 */
var isProduction = function () { return BuildInfo.environment === "production"; };
/*
 * Working with a pallet of boxes: production hides the per-system switch
 * (`MultipleBoxesToggle`) and turns it off in any system loaded with it on
 * (`rehydrateSystemState`).
 */
export var isMultipleBoxesFeatureAvailable = function () { return !isProduction(); };
/*
 * Sense valves and restrictors on suction cups: production offers no cup
 * technology options at all (`useCupTechnologyOptions`).
 */
export var isCupTechnologyFeatureAvailable = function () { return !isProduction(); };
/*
 * Object shapes marked `hiddenInProd` are left out of the shape list in
 * production (`selectObjectShapes`).
 */
export var isObjectShapeAvailable = function (objectShape) {
    return !isProduction() || !objectShape.hiddenInProd;
};
/*
 * The box for targeting a specific Tacton draft ticket (`DeveloperTicket`) is
 * a development aid, never shown in production.
 */
export var isDeveloperTicketAvailable = function () { return !isProduction(); };
